import moment from 'moment';
import { Button, Row } from 'react-bootstrap';
import { Fragment } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { ColumnToggle, Search } from 'react-bootstrap-table2-toolkit';
import axios from 'axios';
import { useLocation, useHistory, Link } from 'react-router-dom';

const ResignationList = ({ resignation, ...props }) => {
    const location = useLocation();
    const history = useHistory();
    const {REACT_APP_API_BACKEND_URL_EXIT_FORM} = process.env;


    async function downloadFileExitForm(valueDetails) {
        try {
            // Making the first API request
            const responses = await axios.get(
                REACT_APP_API_BACKEND_URL_EXIT_FORM + `exit/interview/form/${valueDetails.userID}`,
                {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${props.cognitoToken.idToken.jwtToken}`,
                    }
                }
            );

            // Check response and proceed if form action is "Submitted by HOD"

            if (responses.data.formAction === "Submitted") {
                try {
                    // Making the second API request
                    const response = await axios.get(
                        REACT_APP_API_BACKEND_URL_EXIT_FORM+ `export/exit/form/pdf?userBadgeId=${valueDetails.userID}`,
                        {
                            headers: {
                                'Accept': 'application/json',
                                'Authorization': `Bearer ${props.cognitoToken.idToken.jwtToken}`,
                            },
                            responseType: 'blob', // Set response type as blob
                        }
                    );
                    // Create a blob and download the file
                    const blob = response.data;
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = valueDetails.userName + '_Exit Interview Form.pdf';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                } catch (err) {
                    console.error('Error downloading PDF:', err);
                }
            }
            else if (responses.length === 0) {
                alert("The data not found to download the file.")
            }
            else {
                alert("The Exit Interview form must be completed before proceeding to download the form")
            }

        } catch (err) {
            console.error('Error fetching data:', err);
        }
    }

    async function downloadFileHodComment(valueDetails) {
        try {
            // Making the first API request
            const responses = await axios.get(
                REACT_APP_API_BACKEND_URL_EXIT_FORM + `hod/comment/form/${valueDetails.userID}`,
                {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${props.cognitoToken.idToken.jwtToken}`,
                    }
                }
            );

            // Check response and proceed if form action is "Submitted by HOD"
            if (responses.data.formAction === "Submitted by HOD") {
                try {
                    // Making the second API request
                    const response = await axios.get(
                        REACT_APP_API_BACKEND_URL_EXIT_FORM +`export/hod/form/pdf?userBadgeId=${valueDetails.userID}`,
                        {
                            headers: {
                                'Accept': 'application/json',
                                'Authorization': `Bearer ${props.cognitoToken.idToken.jwtToken}`,
                            },
                            responseType: 'blob', // Set response type as blob
                        }
                    );
                    // Create a blob and download the file
                    const blob = response.data;
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = valueDetails.userName + '_HOD Comment Form.pdf';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                } catch (err) {
                    console.error('Error downloading PDF:', err);
                }
            }
            else if (responses.length === 0) {
                alert("The data not found to download the file.")
            }
            else {
                alert("The HOD comment form must be completed before proceeding to download the form.")
            }

        } catch (err) {
            console.error('Error fetching data:', err);
        }
    }

    const columns = [
        {
            dataField: 'formID',
            text: 'Form ID',
            sort: true,
            sortFunc: (a, b, order, dataField, rowA, rowB) => {
                if (order === 'asc') {
                    return parseInt(a) - parseInt(b)
                }
                else if (order === 'desc') {
                    return parseInt(b) - parseInt(a)
                }
            },
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', textDecoration: 'underline', cursor: 'pointer' },
            headerAttrs: { width: 100 },
            attrs: { width: 100 },
        },
        {
            dataField: 'userID',
            text: 'Applicant Badge ID',
            sort: true,
            sortFunc: (a, b, order, dataField, rowA, rowB) => {
                if (order === 'asc') {
                    return parseInt(a) - parseInt(b)
                }
                else if (order === 'desc') {
                    return parseInt(b) - parseInt(a)
                }
            },
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
        },
        {
            dataField: 'userName',
            text: 'Applicant Name',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer', textTransform: 'capitalize' },
            formatter: (cell, row) => `${row.userName?.toLowerCase()}`,
            headerAttrs: { width: 150 },
            attrs: { width: 150 },
        },
        {
            dataField: 'userFactory',
            text: 'Applicant Factory',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
        },
        {
            dataField: 'userJobGrade',
            text: 'Applicant Job Grade',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 100 },
            attrs: { width: 100 },
            formatter: (cell, row) => {
                if (row.userJobGrade === "") {
                    return `N/A`
                }
                else {
                    return `${row.userJobGrade}`
                }
            },
            csvFormatter: (cell, row) => {
                if (row.userJobGrade === "") {
                    return `N/A`
                }
                else {
                    return `${row.userJobGrade}`
                }
            },
        },
        {
            dataField: 'userDept',
            text: 'Applicant Department',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 160 },
            attrs: { width: 160 },
            formatter: (cell, row) => {
                if (row.userDept === "") {
                    return `N/A`
                }
                else {
                    return `${row.userDept}`
                }
            },
            csvFormatter: (cell, row) => {
                if (row.userDept === "") {
                    return `N/A`
                }
                else {
                    return `${row.userDept}`
                }
            },
        },
        {
            dataField: 'superiorName',
            text: 'Superior Name',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer', textTransform: 'capitalize' },
            formatter: (cell, row) => `${row.superiorName?.toLowerCase()}`,
            headerAttrs: { width: 150 },
            attrs: { width: 150 },
        },
        {
            dataField: 'createdDate',
            text: 'Submission Date',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            formatter: (cell, row) => {
                if ((row.formStatusID == 3 || row.formStatusID == 4) && row.finalCreatedDateAdminRemark) {
                    return `${moment(row.finalCreatedDateAdmin).format('DD/MM/YYYY')}`
                }
                else {
                    return `${moment(row.createdDate).format('DD/MM/YYYY')}`
                }
            },
            csvFormatter: (cell, row) => {
                if ((row.formStatusID == 3 || row.formStatusID == 4) && row.finalCreatedDateAdminRemark) {
                    return `${moment(row.finalCreatedDateAdmin).format('DD/MM/YYYY')}`
                }
                else {
                    return `${moment(row.createdDate).format('DD/MM/YYYY')}`
                }
            },
            headerAttrs: { width: 150 },
            attrs: { width: 150 },
        },
        {
            dataField: 'noticePeriod',
            text: 'Notice Period',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            formatter: (cell, row) => {
                if (!row.noticePeriod) {
                    return `N/A`
                }
                else {
                    return `${row.noticePeriod}`
                }
            },
            csvFormatter: (cell, row) => {
                if (!row.noticePeriod) {
                    return `N/A`
                }
                else {
                    return `${row.noticePeriod}`
                }
            },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
        },
        {
            dataField: 'shortNotice',
            text: 'Short Notice Given',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            formatter: (cell, row) => {
                if (row.shortNotice == 1) {
                    return `Yes`
                }
                else if (row.shortNotice == 0) {
                    return `No`
                }
                else if (row.shortNotice == 2) {
                    return `24 hours resignation`
                }
            },
            csvFormatter: (cell, row) => {
                if (row.shortNotice == 1) {
                    return `Yes`
                }
                else if (row.shortNotice == 0) {
                    return `No`
                }
                else if (row.shortNotice == 2) {
                    return `24 hours resignation`
                }
            },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
        },
        {
            dataField: 'lastDateAfterNotice',
            text: 'Last Working Date',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            formatter: (cell, row) => {
                if ((row.formStatusID == 3 || row.formStatusID == 4) && row.finalCreatedDateAdminRemark) {
                    return `${moment(row.lastWorkingDateAdmin).format('DD/MM/YYYY')}`
                }
                else {
                    if (row.lastDateAfterNotice) {
                        return `${moment(row.lastDateAfterNotice).format('DD/MM/YYYY')}`
                    }
                    else {
                        return `N/A`
                    }
                }
            },
            csvFormatter: (cell, row) => {
                if ((row.formStatusID == 3 || row.formStatusID == 4) && row.finalCreatedDateAdminRemark) {
                    return `${moment(row.lastWorkingDateAdmin).format('DD/MM/YYYY')}`
                }
                else {
                    if (row.lastDateAfterNotice) {
                        return `${moment(row.lastDateAfterNotice).format('DD/MM/YYYY')}`
                    }
                    else {
                        return `N/A`
                    }
                }
            },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
        },
        {
            dataField: 'lastWorkingDate',
            text: 'Last Working Date By Employee',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            formatter: (cell, row) => {
                if ((row.formStatusID == 3 || row.formStatusID == 4) && row.lastWorkingDateAdminRemark) {
                    return `${moment(row.lastWorkingDateEmployeeAdmin).format('DD/MM/YYYY')}`
                }
                else if ((row.formStatusID == 3 || row.formStatusID == 4) && !row.lastWorkingDateAdminRemark) {
                    if (row.lastWorkingDate != '1/1/0001 12:00:00 AM') {
                        return `${moment(row.lastWorkingDate).format('DD/MM/YYYY')}`
                    }
                    else {
                        return `N/A`
                    }
                }
                else {
                    if (row.lastWorkingDate != '1/1/0001 12:00:00 AM') {
                        return `${moment(row.lastWorkingDate).format('DD/MM/YYYY')}`
                    }
                    else {
                        return `N/A`
                    }
                }
            },
            csvFormatter: (cell, row) => {
                if ((row.formStatusID == 3 || row.formStatusID == 4) && row.lastWorkingDateAdminRemark) {
                    return `${moment(row.lastWorkingDateAdmin).format('DD/MM/YYYY')}`
                }
                else if ((row.formStatusID == 3 || row.formStatusID == 4) && !row.lastWorkingDateAdminRemark) {
                    if (row.lastWorkingDate != '1/1/0001 12:00:00 AM') {
                        return `${moment(row.lastWorkingDate).format('DD/MM/YYYY')}`
                    }
                    else {
                        return `N/A`
                    }
                }
                else {
                    if (row.lastWorkingDate != '1/1/0001 12:00:00 AM') {
                        return `${moment(row.lastWorkingDate).format('DD/MM/YYYY')}`
                    }
                    else {
                        return `N/A`
                    }
                }
            },
            sortFunc: (a, b, order, dataField, rowA, rowB) => {
                if (order === 'asc') {
                    return Date.parse(a) - Date.parse(b)
                }
                else if (order === 'desc') {
                    return Date.parse(b) - Date.parse(a)
                }
            },
            headerAttrs: { width: 150 },
            attrs: { width: 150 },
        },
        {
            dataField: 'formStatusName',
            text: 'Form Status',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 140 },
            attrs: { width: 140 },
        },
        {
            dataField: 'reasonLeaving',
            text: 'Reason Leaving',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            formatter: (cell, row) => {
                if (row.reasonLeaving) {
                    return `${row.reasonLeaving}`
                }
                else {
                    return `N/A`
                }
            },
            csvFormatter: (cell, row) => {
                if (row.reasonLeaving) {
                    return `${row.reasonLeaving}`
                }
                else {
                    return `N/A`
                }
            },
            headerAttrs: { width: 160 },
            attrs: { width: 160 },
        },
        {
            dataField: 'computerModel',
            text: 'Computer Model',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            formatter: (cell, row) => {
                if (row.computerModel) {
                    return `${row.computerModel}`
                }
                else {
                    return `N/A`
                }
            },
            csvFormatter: (cell, row) => {
                if (row.computerModel) {
                    return `${row.computerModel}`
                }
                else {
                    return `N/A`
                }
            },
            headerAttrs: { width: 150 },
            attrs: { width: 150 },
        },
        {
            dataField: 'computerSerial',
            text: 'Computer Serial',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            formatter: (cell, row) => {
                if (row.computerSerial) {
                    return `${row.computerSerial}`
                }
                else {
                    return `N/A`
                }
            },
            csvFormatter: (cell, row) => {
                if (row.computerSerial) {
                    return `${row.computerSerial}`
                }
                else {
                    return `N/A`
                }
            },
            headerAttrs: { width: 300 },
            attrs: { width: 300 },
        },
        {
            dataField: 'personalEmail',
            text: 'Personal Email',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            formatter: (cell, row) => {
                if (row.personalEmail) {
                    return `${row.personalEmail}`
                }
                else {
                    return `N/A`
                }
            },
            csvFormatter: (cell, row) => {
                if (row.personalEmail) {
                    return `${row.personalEmail}`
                }
                else {
                    return `N/A`
                }
            },
            headerAttrs: { width: 250 },
            attrs: { width: 250 },
        },
        {
            dataField: 'HODCommentForm',
            text: 'HOD Comment Form',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', textDecoration: 'underline', cursor: 'pointer' },
            formatter: (cell, row, rowIndex, formatExtraData) => {
                return (
                    <button
                        onClick={(e) => {
                            e.preventDefault(); // Prevent the default action to stop scrolling to the top
                            e.stopPropagation(); // Stop the event from bubbling up
                            history.push({
                                pathname: 'resignation/hodcommentForm',
                                state: { rowData: row }
                            });
                        }}
                        style={{ textDecoration: 'underline', cursor: 'pointer', background: 'none', border: 'none', padding: 0 }}
                    >
                        View
                    </button>
                );
            },
            headerAttrs: { width: 250 },
            attrs: { width: 250 },
        },
        {
            dataField: 'HOD Form',
            text: 'HOD Comment Download',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', textDecoration: 'underline', cursor: 'pointer' },
            formatter: (cell, row, rowIndex, formatExtraData) => {
                return (
                    <button
                        onClick={(e) => {
                            e.preventDefault(); // Prevent the default action to stop scrolling to the top
                            e.stopPropagation(); // Stop the event from bubbling up
                            downloadFileHodComment(row);
                        }}
                        style={{ textDecoration: 'underline', cursor: 'pointer', background: 'none', border: 'none', padding: 0 }}
                    >
                        Download
                    </button>
                );
            },
            headerAttrs: { width: 250 },
            attrs: { width: 250 },
        },
        {
            dataField: 'Exit Form',
            text: 'Exit Interview Download',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', textDecoration: 'underline', cursor: 'pointer' },
            formatter: (cell, row, rowIndex, formatExtraData) => {
                return (
                    <button
                        onClick={(e) => {
                            e.preventDefault(); // Prevent the default action to stop scrolling to the top
                            e.stopPropagation(); // Stop the event from bubbling up
                            downloadFileExitForm(row);
                        }}
                        style={{ textDecoration: 'underline', cursor: 'pointer', background: 'none', border: 'none', padding: 0 }}
                    >
                        Download
                    </button>
                );
            },
            headerAttrs: { width: 250 },
            attrs: { width: 250 },
        },
        {
            dataField: 'formAction',
            text: 'Exit Form Status',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            formatter: (cell, row) => {
                if (row.formAction) {
                    return `${row.formAction}`
                }
                else {
                    return `N/A`
                }
            },
        },

        {
            dataField: 'formActionHOD',
            text: 'HOD Comment Form Status',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            formatter: (cell, row) => {
                if (row.formActionHOD) {
                    return `${row.formActionHOD}`
                }
                else {
                    return `N/A`
                }
            },
        },
        {
            dataField: 'joinDate',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            hidden: true,
            formatter: (cell, row) => {
                if (row.joinDate) {
                    return `${row.joinDate}`
                }
                else {
                    return `N/A`
                }
            },
        },
        {
            dataField: 'positionUser',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            hidden: true,
            formatter: (cell, row) => {
                if (row.positionUser) {
                    return `${row.positionUser}`
                }
                else {
                    return `N/A`
                }
            },
        },
        {
            dataField: 'lastPerformance',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            hidden: true,
            formatter: (cell, row) => {
                if (row.lastPerformance) {
                    return `${row.lastPerformance}`
                }
                else {
                    return `N/A`
                }
            },
        },
        {
            dataField: 'periodFrom',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            hidden: true,
            formatter: (cell, row) => {
                if (row.periodFrom) {
                    return `${row.periodFrom}`
                }
                else {
                    return `N/A`
                }
            },
        },
        {
            dataField: 'periodTo',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            hidden: true,
            formatter: (cell, row) => {
                if (row.periodTo) {
                    return `${row.periodTo}`
                }
                else {
                    return `N/A`
                }
            },
        },
        {
            dataField: 'bmi',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            hidden: true,
            formatter: (cell, row) => {
                if (row.bmi) {
                    return `${row.bmi}`
                }
                else {
                    return `N/A`
                }
            },
        },
        {
            dataField: 'unpaidLeave',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            hidden: true,
            formatter: (cell, row) => {
                if (row.unpaidLeave) {
                    return `${row.unpaidLeave}`
                }
                else {
                    return `N/A`
                }
            },
        },
        {
            dataField: 'hospLeave',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            hidden: true,
            formatter: (cell, row) => {
                if (row.hospLeave) {
                    return `${row.hospLeave}`
                }
                else {
                    return `N/A`
                }
            },
        },
        {
            dataField: 'emergencyLeave',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            hidden: true,
            formatter: (cell, row) => {
                if (row.emergencyLeave) {
                    return `${row.emergencyLeave}`
                }
                else {
                    return `N/A`
                }
            },
        },
        {
            dataField: 'absenteeism',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            hidden: true,
            formatter: (cell, row) => {
                if (row.absenteeism) {
                    return `${row.absenteeism}`
                }
                else {
                    return `N/A`
                }
            },
        },
        {
            dataField: 'warningLetter',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            hidden: true,
            formatter: (cell, row) => {
                if (row.warningLetter) {
                    return `${row.warningLetter}`
                }
                else {
                    return `N/A`
                }
            },
        },
        {
            dataField: 'rewardLetter',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            hidden: true,
            formatter: (cell, row) => {
                if (row.rewardLetter) {
                    return `${row.rewardLetter}`
                }
                else {
                    return `N/A`
                }
            },
        },
        {
            dataField: 'suggestion',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            hidden: true,
            formatter: (cell, row) => {
                if (row.suggestion) {
                    return `${row.suggestion}`
                }
                else {
                    return `N/A`
                }
            },
        },
        {
            dataField: 'trainingLetter',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            hidden: true,
            formatter: (cell, row) => {
                if (row.trainingLetter) {
                    return `${row.trainingLetter}`
                }
                else {
                    return `N/A`
                }
            },
        },
        {
            dataField: 'reminderLetter',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            hidden: true,
            formatter: (cell, row) => {
                if (row.reminderLetter) {
                    return `${row.reminderLetter}`
                }
                else {
                    return `N/A`
                }
            },
        },
        {
            dataField: 'requestBy',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            hidden: true,
            formatter: (cell, row) => {
                if (row.requestBy) {
                    return `${row.requestBy}`
                }
                else {
                    return `N/A`
                }
            },
        },
        {
            dataField: 'requestorName',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            hidden: true,
            formatter: (cell, row) => {
                if (row.requestorName) {
                    return `${row.requestorName}`
                }
                else {
                    return `N/A`
                }
            },
        },
        {
            dataField: 'requestorUsername',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            hidden: true,
            formatter: (cell, row) => {
                if (row.requestorUsername) {
                    return `${row.requestorUsername}`
                }
                else {
                    return `N/A`
                }
            },
        },
        {
            dataField: 'formActionHodComment',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            hidden: true,
            formatter: (cell, row) => {
                if (row.formActionHodComment) {
                    return `${row.formActionHodComment}`
                }
                else {
                    return `N/A`
                }
            },
        },
        {
            dataField: 'hodUsername',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            hidden: true,
            formatter: (cell, row) => {
                if (row.hodUsername) {
                    return `${row.hodUsername}`
                }
                else {
                    return `N/A`
                }
            },
        },
        {
            dataField: 'hodPosition',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center', cursor: 'pointer' },
            headerAttrs: { width: 120 },
            attrs: { width: 120 },
            hidden: true,
            formatter: (cell, row) => {
                if (row.hodPosition) {
                    return `${row.hodPosition}`
                }
                else {
                    return `N/A`
                }
            },
        },
    ]

    const rowEvents = {
        onClick: (e, row) => {
            history.push({
                pathname: 'resignation/resignationform',
                state: { rowData: row }
            });

        },
    };

    const defaultSorted = [{
        dataField: 'formID',
        order: 'asc'
    }];

    const { SearchBar, ClearSearchButton } = Search;

    const { ToggleList } = ColumnToggle;

    const ExportCSVButton = (props) => {
        const handleClick = () => {
            props.onExport();
        };

        return (
            <Button
                variant='success'
                onClick={handleClick}
                style={{ float: 'right', color: 'white' }}
            >
                Export to CSV
            </Button>
        );
    };

    // Put HOD Comment Excel button here
    const ExportHodCSVButton = () => {

        return (
            <Button
                variant='success'
                style={{
                    float: 'right'
                }}>
                <Link to='/reports/hodCommentForm' style={{ textDecoration: 'white', color: '#FFFFFF' }}>
                    HOD Comment List CSV
                </Link>

            </Button>



        );
    };

    return (
        <Fragment>

            <ToolkitProvider
                keyField='id'
                data={resignation}
                columns={columns}
                columnToggle
                search={{ searchFormatted: true }}
                exportCSV={{
                    fileName: 'Resignation Report.csv',
                    onlyExportFiltered: true, exportAll: false
                }}
            >
                {
                    props => (
                        <div style={{ marginTop: '10px' }}>
                            <SearchBar {...props.searchProps} />
                            <ClearSearchButton {...props.searchProps} />
                            <ExportHodCSVButton />
                            <ExportCSVButton {...props.csvProps} />
                            <hr />
                            <div style={{ marginTop: '20px' }}><strong>Display Options</strong></div>
                            <ToggleList
                                contextual='grievance-primary'
                                btnClassName='grievance-toggle-column-btn-custom-class'
                                {...props.columnToggleProps}
                            />
                            <BootstrapTable
                                classes='qrevent-table'
                                bordered={false}
                                {...props.baseProps}
                                pagination={paginationFactory()}
                                headerWrapperClasses='infohub-header'
                                noDataIndication='List is empty.'
                                rowEvents={rowEvents}
                                defaultSorted={defaultSorted}
                            />
                        </div>
                    )
                }
            </ToolkitProvider>
        </Fragment>
    );
};

export default ResignationList;